import * as z from "zod";
import {
  developerLogEntrySchema,
  developerLogKindSchema,
  developerLogOutcomeSchema,
} from "./entry";

/**
 * Filters shared by the merchant RPCs and public API v3, so both surfaces
 * offer the same capabilities. Every filter is optional and they combine with AND.
 */
export const developerLogFilterSchema = z.object({
  kind: developerLogKindSchema.optional(),
  /** ISO-8601 instants, inclusive start and exclusive end. */
  from: z.iso.datetime().optional(),
  to: z.iso.datetime().optional(),
  outcome: developerLogOutcomeSchema.optional(),
  errorCode: z.string().optional(),
  /** A Redo object id the entry is about, such as an order or return. */
  relatedId: z.string().optional(),
  /** An entry id, a related object id or a webhook event id. */
  query: z.string().optional(),
  statusCode: z.number().int().optional(),
  method: z.string().optional(),
  /** Matches the start of the route template, e.g. `/v2.2/stores/{storeId}/returns`. */
  endpoint: z.string().optional(),
  apiVersion: z.string().optional(),
  tokenId: z.string().optional(),
  topic: z.string().optional(),
  endpointId: z.string().optional(),
  eventId: z.string().optional(),
  artifactId: z.string().optional(),
  contractId: z.string().optional(),
  targetId: z.string().optional(),
  sourceKind: z.string().optional(),
  sourceId: z.string().optional(),
});
export type DeveloperLogFilter = z.infer<typeof developerLogFilterSchema>;

export const developerLogPageSchema = z.object({
  entries: z.array(developerLogEntrySchema),
  nextCursor: z.string().nullable(),
});
export type DeveloperLogPage = z.infer<typeof developerLogPageSchema>;

export const DEVELOPER_LOG_MAX_PAGE_SIZE = 100;
export const DEVELOPER_LOG_DEFAULT_PAGE_SIZE = 25;
